import React, { Component } from 'react'
import { withRouter } from "react-router";

class ScrollToTop extends Component {
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            // a hash means the target page scrolls to its own anchor
            // (e.g. /#about-college, /#vision-mission) — don't fight it
            if (this.props.location.hash) return
            window.scrollTo(0, 0)
        }
    }
  render() {
    return this.props.children
  }
}
export default withRouter(ScrollToTop)
